module.exports = __webpack_public_path__ + "media/images/ticket/navi_sports-840247cb29a38dd84b11c13472a24859.png";